module.exports = "<p>\n  listnews works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/news/listnews/listnews.component.html
// module id = ../../../../../src/app/components/pages/news/listnews/listnews.component.html
// module chunks = main